import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as prizeActions from '../prize.actions';
import { getMainPrize } from '../prize.selectors';
import {Localize} from '../../../locale/localization';
import {StyledPrizeWrap} from './ui/index';

class MainPrizeFeatureBlock extends Component {
  render() {
    const {
      mainPrize,
    } = this.props;
    
    if(!mainPrize) return null;

    return (
      <StyledPrizeWrap>
        <div className="text">
          <h4>{Localize('prize.main.header')}</h4>
          <p className="name">{mainPrize.name}</p>
          <p className="score">{mainPrize.price} {Localize("score")}</p>
        </div>
				{mainPrize.image &&
          <figure>
            <img src={mainPrize.image} alt={Localize('prize.image.alt')} />
          </figure>
				}
      </StyledPrizeWrap>
    );
  }
};

const mapStateToProps = (state) => {
  const mainPrize = getMainPrize(state);
  return {
    mainPrize,
  };
};

const ConnectedMainPrizeFeatureBlock = connect(
  mapStateToProps,
  Object.assign({}, prizeActions),
)(MainPrizeFeatureBlock);

export default ConnectedMainPrizeFeatureBlock;


// WEBPACK FOOTER //
// ./src/modules/prize/components/MainPrizeFeatureBlock.js